'use client';

import { useRouter } from '@bprogress/next/app';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { toastBase } from '@/ui-kit/toast';

const OAUTH_ERROR_PARAM = 'oauthError';
const OAUTH_ERROR_TID = 'tid';

export function OauthErrorToast() {
  const t = useTranslations();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams.get(OAUTH_ERROR_PARAM) !== OAUTH_ERROR_TID) {
      return;
    }

    toastBase(t('login.oauthError'), { status: 'error' });

    const next = new URLSearchParams(searchParams.toString());
    next.delete(OAUTH_ERROR_PARAM);

    const query = next.toString();
    router.replace(query ? `/?${query}` : '/', { scroll: false });
  }, [router, searchParams, t]);

  return null;
}
